import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetBuildingById, AddNewBuilding, UpdateBuilding, DeleteBuilding, GetBuildings } from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetBuildings() {
    return useQuery('buildings', () => GetBuildings(), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.buildings || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch buildings", error);
            console.error("Error fetching buildings:", error);
        }
    });
}

export function useGetBuildingsByBranchId(branchId) {
    return useQuery(
        ['buildings', branchId],
        () => GetBuildings(branchId),
        {
            enabled: !!branchId,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
            select: (data) => data?.data?.buildings || [],
            onError: (error) => {
                NotifyError("Failed to fetch buildings", error);
                console.error("Error fetching buildings by branch:", error);
            },
        }
    );
}

export function useGetBuildingById(buildingId) {
    return useQuery(
        ['building', buildingId],
        () => GetBuildingById(buildingId),
        {
            enabled: !!buildingId,
            staleTime: 5 * 60 * 1000, // 5 minutes
            onError: (error) => {
                NotifyError("Failed to fetch building details", error);
                console.error("Error fetching building details:", error);
            }
        }
    );
}

export function useAddBuilding() {
    const queryClient = useQueryClient();
    return useMutation(({ branchId, data }) => AddNewBuilding(branchId, data), {
        onSuccess: (_data, variables) => {
            Notify("Building added successfully");

            queryClient.invalidateQueries('buildings');
            if (variables?.branchId) {
                queryClient.invalidateQueries(['buildings', variables.branchId]);
            }
        },
        onError: (error) => {
            NotifyError("Failed to add building", error);
            console.error("Error adding building:", error);
        }
    });
}

export function useUpdateBuilding() {
    const queryClient = useQueryClient();
    return useMutation(({ buildingId, data }) => UpdateBuilding(buildingId, data), {
        onSuccess: () => {
            Notify("Building updated successfully");

            queryClient.invalidateQueries('buildings');
            queryClient.invalidateQueries(['building']);
        },
        onError: (error) => {
            NotifyError("Failed to update building", error);
            console.error("Error updating building:", error);
        }
    });
}

export function useDeleteBuilding() {
    const queryClient = useQueryClient();
    return useMutation(({ buildingId }) => DeleteBuilding(buildingId), {
        onSuccess: () => {
            Notify("Building deleted successfully");

            queryClient.invalidateQueries('buildings');
        },
        onError: (error) => {
            NotifyError("Failed to delete building", error);
            console.error("Error deleting building:", error);
        }
    });
}
